/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Motor_YachtInputs */

const en_val_motor_yacht = /** @type {(inputs: Val_Motor_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motor Yacht`)
};

const es_val_motor_yacht = /** @type {(inputs: Val_Motor_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yate a motor`)
};

const fr_val_motor_yacht = /** @type {(inputs: Val_Motor_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yacht à moteur`)
};

const de_val_motor_yacht = /** @type {(inputs: Val_Motor_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motoryacht`)
};

const ja_val_motor_yacht = /** @type {(inputs: Val_Motor_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モーターヨット`)
};

const zh_val_motor_yacht = /** @type {(inputs: Val_Motor_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`机动游艇`)
};

const ar_val_motor_yacht = /** @type {(inputs: Val_Motor_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يخت بمحرك`)
};

const id_val_motor_yacht = /** @type {(inputs: Val_Motor_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapal Pesiar Motor`)
};

const it_val_motor_yacht = /** @type {(inputs: Val_Motor_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yacht a Motore`)
};

const ru_val_motor_yacht = /** @type {(inputs: Val_Motor_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моторная яхта`)
};

const pt_val_motor_yacht = /** @type {(inputs: Val_Motor_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iate a Motor`)
};

const ko_val_motor_yacht = /** @type {(inputs: Val_Motor_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모터 요트`)
};

/**
* | output |
* | --- |
* | "Motor Yacht" |
*
* @param {Val_Motor_YachtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_motor_yacht = /** @type {((inputs?: Val_Motor_YachtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Motor_YachtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_motor_yacht(inputs)
	if (locale === "es") return es_val_motor_yacht(inputs)
	if (locale === "fr") return fr_val_motor_yacht(inputs)
	if (locale === "de") return de_val_motor_yacht(inputs)
	if (locale === "ja") return ja_val_motor_yacht(inputs)
	if (locale === "zh") return zh_val_motor_yacht(inputs)
	if (locale === "ar") return ar_val_motor_yacht(inputs)
	if (locale === "id") return id_val_motor_yacht(inputs)
	if (locale === "it") return it_val_motor_yacht(inputs)
	if (locale === "ru") return ru_val_motor_yacht(inputs)
	if (locale === "pt") return pt_val_motor_yacht(inputs)
	return ko_val_motor_yacht(inputs)
});